import { BypassWeakType } from '../typescript-utils';

export function getClassStyle(
  content: BypassWeakType<{ style?: Array<{ id: string; name: string }> }>,
) {
  const styleName = content.style?.[0] ? content?.style?.[0].name : '';
  return styleName;
}
